import { library } from '@fortawesome/fontawesome-svg-core'
import { faArchive } from '@fortawesome/pro-regular-svg-icons/faArchive'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo'
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear'
import { faHome } from '@fortawesome/pro-regular-svg-icons/faHome'
import { faListRadio } from '@fortawesome/pro-regular-svg-icons/faListRadio'
import { faThumbsDown } from '@fortawesome/pro-regular-svg-icons/faThumbsDown'
import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons/faThumbsUp'
import React from 'react'

library.add(faListRadio, faThumbsDown, faThumbsUp, faFile, faCircleInfo, faHome, faArchive, faGear)

export default function InitStructures() {
  return <></>
}
